globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Emailing = appCustomerSpace.Modals.Emailing || {};

appCustomerSpace.Modals.Emailing.SendTestNewsletter = (function(superClass) {

utils.extend(SendTestNewsletter, superClass);

function SendTestNewsletter() {
  return SendTestNewsletter.__super__.constructor.apply(this, arguments);
}

$.extend(SendTestNewsletter.prototype, {
  init: function() {
    appCustomerSpace.LimitlessPlugins.initPlugins(this.$html);

    return SendTestNewsletter.__super__.init.apply(this, arguments);
  },

  callbackSuccess: function(data) {
    var modal = this;
    if (data.response == 1) {
      new PNotify({icon: 'icon-checkmark3', title: "L'email va être envoyé", type: 'success'});
    } else if (data.error === 'missing_sender') {
      modal.close();
      new PNotify({icon: 'icon-cross2', title: "Envoi impossible : aucun expéditeur configuré sur cette newsletter", type: 'error'});
    } else {
      modal.close();
      new PNotify({icon: 'icon-cross2', title: "Erreur lors de l'envoi de l'email", type: 'error'});
    }

    return SendTestNewsletter.__super__.callbackSuccess.apply(this, arguments);
  }
});

return SendTestNewsletter;

})(appCustomerSpace.Modal);
